<h1 mat-dialog-title>Kundengutschrift</h1>
<div mat-dialog-content>
    <kiene-gutschrift-details [kundengutschrift]="kundengutschrift" (saved)="saved()"></kiene-gutschrift-details>
</div>
<div mat-dialog-actions>
    <span class="spacer"></span>
    <button mat-button (click)="close()">Schlie&szlig;en</button>
</div>
